<template>
    <div class="OrderNav">
        <div class="navItem" @click="chooseNav('/orderManage/orderList')" :class="{ active: currentPath === '/orderManage/orderList' }">
            销售订单
        </div>
        <div v-if="isAdmin" class="navItem" @click="chooseNav('/orderManage/orderRecycle')" :class="{ active: currentPath === '/orderManage/orderRecycle' }">
            订单回收站
        </div>
        <div class="navItem" @click="chooseNav('/quotation/quotationList')" :class="{ active: currentPath === '/quotation/quotationList' }">
            销售报价单
        </div>
        <div v-if="isAdmin" class="navItem" @click="chooseNav('/quotation/quotationRecycle')" :class="{ active: currentPath === '/quotation/quotationRecycle' }">
            报价单回收站
        </div>
    </div>
</template>

<script>
export default {
    props: ["currentPath"],
    data() {
        return {
            isAdmin: false,
        };
    },
    methods: {
        chooseNav(index) {
            this.$emit("chooseNav",index);
        },
    },
    mounted() {
        this.isAdmin = localStorage.userInfo ? JSON.parse(localStorage.userInfo).isAdmin : false;
    },
};
</script>

<style lang="scss" scoped>
@import '@/scss/common.scss';
.OrderNav {
    width: 200px;
    height: calc(100vh - 140px);
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    .oneClass{
        padding: 5px 15px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        color: #aaa;
    }

    .navItem {
        cursor: pointer;
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
        color: #000;
        font-size: 14px;
        &.active {
            color: #fff;
            background: $themeColor;
        }
        img{
            vertical-align: text-bottom;
            margin-right: 5px;
        }
    }
}
</style>